import React from 'react';

import { UtilInstance } from '../../../../../../util/Util';
import { getPolyglot } from '../../../../../../i18n';
import { useAppSelector } from '../../../../../../redux/store.model';
import DeviceModel from '../../../../../../redux/commander/api/DeviceModel';
import useCommanderStatus from '../../../../../../redux/commander/commander-status/hooks/useCommanderStatus';
import { getDeviceDataById } from '../../../../../../redux/commander/selectors';
import { useGroupById } from '../../../../../../redux/groups/hooks/useGroupById';
import { getRightUserUtilSelector } from '../../../../../../redux/rights/selectors';

const proxyBackendURL = UtilInstance.getCommanderProxyURL();

interface MerchandiserUIActionProps {
  merchandiserId: string | undefined;
  variant?: 'icon' | 'menuItem';
}
export const useMerchandiserUIAction = (props: MerchandiserUIActionProps) => {
  const { merchandiserId } = props;
  const polyglot = getPolyglot();
  const accessToken = useAppSelector((state) => state.auth.accessToken);
  const { data: group } = useGroupById(merchandiserId ?? '');
  const deviceId = group?.devices[0] ?? '';
  const deviceInfo = useAppSelector((state) =>
    getDeviceDataById(state, { deviceId: deviceId ?? '' })
  );
  const rightUserUtil = useAppSelector(getRightUserUtilSelector);
  const hasRightToSeeVPN =
    rightUserUtil.hasRightsToAccessCommanderViaVPNInGroup(merchandiserId ?? '');

  let tooltipContent = polyglot.t('device.tooltip.open_window_ui');

  // Device status
  const { commanderStatus, isLoading: loadingCommanderStatus } =
    useCommanderStatus(deviceId);
  const cloudConnectivityStatus = new DeviceModel().cloudConnectivityStatus(
    deviceInfo?.lastPing,
    commanderStatus
  );

  if (!cloudConnectivityStatus.cloudConnectivityVPN) {
    tooltipContent = polyglot.t('device.tooltip.limited_ui_info');
  }

  const openDeviceUI = () => {
    const deviceRedirectURL = `${proxyBackendURL}/${deviceInfo?.ip}/?token=${accessToken}`;
    window.open(deviceRedirectURL, '_blank');
  };

  return {
    onClick: openDeviceUI,
    tooltip: tooltipContent,
    showButton: false,
    disabled: !cloudConnectivityStatus.cloudConnectivityVPN,
  };
};

export default useMerchandiserUIAction;
